module.exports = __webpack_public_path__ + "static/istanbul-skyline-2-17fc4acc32952b1b5b4dc206bd8179f3.jpg";